import React, {useMemo} from 'react';

const colors = ['#69D994', '#9DDEAD', '#B3E5C2', '#E5F6EB'];
const burstCount = 15;
const particleCount = 6;

const randRange = (min: number, max: number) => (
	Math.random() * (max - min) + min
);

const useBurstingBubbles = () => (
	useMemo(() => {
		const generated: JSX.Element[] = [];
		for (let i = 0; i < burstCount; i++) {
			const x = randRange(25, 75);
			const y = randRange(0, 100);
			const maxRadius = randRange(3, 11);
			const colorIndex = i % 4;
			const duration = randRange(2, 5);
			const delay = randRange(0, 5);

			// Create bubble that expands then "pops"
			generated.push(
				<circle
					key={`burst-${i}`}
					cx={x}
					cy={y}
					r='0'
					fill={colors[colorIndex]}
					opacity='0'
				>
					{/* Grow phase */}
					<animate
						attributeName='r'
						values={`0;${maxRadius}`}
						dur={`${duration * 0.8}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
					/>
					<animate
						attributeName='opacity'
						values='0;0.7;0.8;0'
						dur={`${duration}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
					/>
				</circle>
			);

			// Create burst particles
			for (let j = 0; j < particleCount; j++) {
				const angle = (j / particleCount) * 360;
				const particleSize = randRange(0.5, 1.5);
				const particleDistance = randRange(maxRadius, maxRadius + 5);

				// Calculate end position
				const radians = angle * Math.PI / 180;
				const endX = x + particleDistance * Math.cos(radians);
				const endY = y + particleDistance * Math.sin(radians);

				generated.push(
					<circle
						key={`particle-${i}-${j}`}
						cx={x}
						cy={y}
						r={particleSize}
						fill={colors[colorIndex]}
						opacity='0'
					>
						<animate
							attributeName='cx'
							values={`${x};${endX}`}
							dur={`${duration}s`}
							begin={`${delay + duration * 0.7}s`}
							repeatCount='indefinite'
						/>
						<animate
							attributeName='cy'
							values={`${y};${endY}`}
							dur={`${duration}s`}
							begin={`${delay + duration * 0.7}s`}
							repeatCount='indefinite'
						/>
						<animate
							attributeName='opacity'
							values='0;0.8;0'
							dur={`${duration}s`}
							begin={`${delay + duration * 0.7}s`}
							repeatCount='indefinite'
						/>
						<animate
							attributeName='r'
							values={`${particleSize};${particleSize/2}`}
							dur={`${duration}s`}
							begin={`${delay + duration * 0.7}s`}
							repeatCount='indefinite'
						/>
					</circle>
				);
			}
		}
		return generated;
	}, [])
);

export const BurstingBubbles: React.FC = () => {
	const elements = useBurstingBubbles();
	return (
		<div>
			<svg
				width='100%'
				height='100%'
				viewBox='0 0 100 100'
				preserveAspectRatio='none'
			>
				{elements}
			</svg>
		</div>
	);
};
